<section class="container pt-2">
  <div class="row">
    <div class="col-md-8 offset-lg-1 pb-5 mb-2 mb-lg-4 pt-md-5 mt-n3 mt-md-0 text-center">
      <h1 class="service-maintenance__title">{{ heading() }}</h1>
      <p class="service-maintenance__message">{{ message() }}</p>
      <p class="service-maintenance__support">
        Questions? Contact
        <a href="mailto:support@appliedbiox.com">support&#64;appliedbiox.com</a>.
      </p>
    </div>
  </div>
</section>
